(function () {
  'use strict';

  angular.module('ringbaPortal').filter('selectedTagsToText', selectedTagsToText);

  function selectedTagsToText(
    $filter
  ) {
    'ngInject';

    return function (selectedTags) {
      if (!selectedTags) {
        return;
      }

      const tagToText = [];
      selectedTags.forEach(function (t) {
        tagToText.push(_getTagDescription(t));
      });

      return tagToText.join(' | ');
    };

    function _getTagDescription(tag) {
      if (!tag) {
        return;
      }

      return $filter('camelCaseFormat')(tag.tagSource) + ' - '
            + $filter('camelCaseFormat')(tag.tagType) + ' - '
            + $filter('camelCaseFormat')(tag.tagName);
    }
  }
})();
